export const SERVICE_KEYS = [
  'blackfridaytickets',
  'epilation',
  'packminceurcomplet',
  'teeth',
  'hydrafacial',
  'microneedling',
  'hifu',
  'powershape',
  'pressotherapie',
  'carbonpeel',
  'cryolipolyse',
  'gynecomastie',
] as const;

export type ServiceKey = (typeof SERVICE_KEYS)[number];

export const SERVICE_PRICING_OPTIONS: Partial<Record<ServiceKey, readonly { value: string; label: string }[]>> = {
  blackfridaytickets: [
    { value: 'black_pack_minceur', label: 'Black Pack Minceur 999 DH' },
    { value: 'laser_barbe', label: 'Laser Barbe 149 DH/zone' },
  ],
  epilation: [
  { value: 'per_zone_session', label: '300 DH par zone / séance' },
  { value: 'six_sessions', label: '6 séances à 1500 DH / zone' },
  ],
  packminceurcomplet: [
    { value: 'basic', label: 'Pack Basic : 3500 DH' },
    { value: 'complete', label: 'Pack Complet : 5000 DH' },
  ],
  teeth: [{ value: 'per_session', label: '1500 DH la séance' }],
  hydrafacial: [{ value: 'per_session', label: '500 DH la séance' },
    { value: 'five_sessions', label: '5 séances à 2000 DH' },
  ],
  microneedling: [{ value: 'per_session', label: '1000 DH la séance' },
    { value: 'three_sessions', label: '3 séances à 2500 DH' },
  ],
  hifu: [{ value: 'per_session', label: '1300 DH la séance' },
    { value: 'three_sessions', label: '3 séances à 3000 DH' },
  ],
  gynecomastie: [
    { value: 'per_session', label: '1300 DH la séance' },
    { value: 'three_sessions', label: '3 séances à 3000 DH' },
  ],
  powershape: [
    { value: 'per_session', label: '350 DH la séance' },
    { value: 'ten_sessions', label: '10 séances à 3000 DH' },
  ],
  pressotherapie: [
    { value: 'per_session', label: '300 DH la séance' },
    { value: 'ten_sessions', label: '10 séances à 2000 DH' },
  ],
  carbonpeel: [{ value: 'per_session', label: '1000 DH la séance' },
    { value: 'three_sessions', label: '3 séances à 2000 DH' },
  ],
  cryolipolyse: [{ value: 'per_session', label: '1000 DH la séance' },
    { value: 'three_sessions', label: '3 séances à 2500 DH' },
  ],
};

export const SERVICE_PARAM_ALIASES: Record<string, ServiceKey> = {
  blackfridaytickets: 'blackfridaytickets',
  'black-friday-tickets': 'blackfridaytickets',
  'offres-black-friday-tickets': 'blackfridaytickets',
  gynecomastie: 'gynecomastie',
  'traitement-gynecomastie': 'gynecomastie',
  epilation: 'epilation',
  'epilation-laser': 'epilation',
  'epilation-laser-300': 'epilation',
  packminceurcomplet: 'packminceurcomplet',
  'pack-minceur-complet': 'packminceurcomplet',
  teeth: 'teeth',
  blanchimentdentaire: 'teeth',
  'blanchiment-dentaire': 'teeth',
  hydrafacial: 'hydrafacial',
  'hydrafacial-complet': 'hydrafacial',
  'hydra-facial': 'hydrafacial',
  microneedling: 'microneedling',
  'micro-needling': 'microneedling',
  hifu: 'hifu',
  'hi-fu': 'hifu',
  powershape: 'powershape',
  'power-shape': 'powershape',
  pressotherapie: 'pressotherapie',
  'pressothérapie': 'pressotherapie',
  carbonpeel: 'carbonpeel',
  'carbon-peel': 'carbonpeel',
  'carbon peel': 'carbonpeel',
  bodycare: 'hydrafacial',
  'body-care': 'hydrafacial',
  weightloss: 'packminceurcomplet',
  'weight-loss': 'packminceurcomplet',
  skincare: 'hydrafacial',
  'skin-care': 'hydrafacial',
  packhydrafacialcarbonpeelteeth: 'hydrafacial',
  'pack-hydrafacial-carbon-peel-teeth': 'hydrafacial',
  'pack-hydrafacial-carbon-peel-teeth-whitening': 'hydrafacial',
  'pack-hydrafacial-carbon-peel-blanchiment-dentaire': 'hydrafacial',
  'hydrafacial-carbon-peel-blanchiment-dentaire': 'hydrafacial',
  'pack-hydrafacial-&-carbon-peel-+-blanchiment-dentaire': 'hydrafacial',
  'pack-hydrafacial-&-carbon-peel-blanchiment-dentaire': 'hydrafacial',
  'باك-الهيدرافاشيال-والكربون-بيل-وتبييض-الأسنان': 'hydrafacial',
  'hydrafacial-carbon-peel-teeth-whitening': 'hydrafacial',
};

const SERVICE_LABELS: Record<'fr' | 'ar' | 'en', Record<ServiceKey, string>> = {
  fr: {
    blackfridaytickets: 'OFFRES BLACK FRIDAY (TICKETS)',
    epilation: 'EPILATION LASER',
    packminceurcomplet: 'TRAITEMENT MINCEUR',
    teeth: 'BLANCHIMENT DENTAIRE',
    hydrafacial: 'HYDRAFACIAL COMPLET',
    microneedling: 'MICRONEEDLING',
    hifu: 'HIFU VISAGE',
    powershape: 'POWER SHAPE / LIPOCAVITATION',
    pressotherapie: 'PRESSOTHERAPIE',
    carbonpeel: 'CARBON PEEL',
    cryolipolyse: 'CRYOLIPOLYSE',
    gynecomastie: 'TRAITEMENT GYNÉCOMASTIE',
  },
  ar: {
    blackfridaytickets: 'عروض الجمعة السوداء (تذاكر)',
    epilation: 'إبليشن ليزر',
    packminceurcomplet: 'باك التخسيس الكامل',
    teeth: 'تبييض الأسنان',
    hydrafacial: 'هيدرافيشل كامل',
    microneedling: 'ميكرونيدلينغ',
    hifu: 'HIFU للوجه',
    powershape: 'باور شيب / ليبوكافيتيشن',
    pressotherapie: 'بريسوثيرابي',
    carbonpeel: 'كاربون بيل',
    cryolipolyse: 'كرايوليبوليز',
    gynecomastie: 'علاج التثدي',
  },
  en: {
    blackfridaytickets: 'BLACK FRIDAY OFFERS (TICKETS)',
    epilation: 'EPILATION LASER',
    packminceurcomplet: 'COMPLETE SLIMMING PACK',
    teeth: 'TEETH WHITENING',
    hydrafacial: 'HYDRAFACIAL COMPLETE',
    microneedling: 'MICRONEEDLING',
    hifu: 'FACIAL HIFU',
    powershape: 'POWER SHAPE / LIPOCAVITATION',
    pressotherapie: 'PRESSOTHERAPY',
    carbonpeel: 'CARBON PEEL',
    cryolipolyse: 'CRYOLIPOLYSIS',
    gynecomastie: 'GYNECOMASTIA TREATMENT',
  },
};

function normalizeLanguage(language: string): 'fr' | 'ar' | 'en' {
  if (language === 'fr' || language === 'ar' || language === 'en') {
    return language;
  }
  return 'en';
}

export function getServiceLabel(service: string, language: string): string {
  const normalizedLanguage = normalizeLanguage(language);
  const labels = SERVICE_LABELS[normalizedLanguage];
  return labels[service as ServiceKey] || service;
}
